function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1285.062 217.65h-987.71c-6.444 0-44.651 92.677-50.942 92.677s1.841-297.826-4.6-297.826-48.182 203.46-54.014 203.46h-80.4l-107.2 1.688",
  fill: "none",
  stroke: "rgba(9,191,255,0.6)",
  strokeMiterlimit: 10,
  strokeWidth: 25,
  opacity: 0.13
});

function SvgPulseLine2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1285.062,
    height: 322.826,
    viewBox: "0 0 1285.062 322.826"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjg1LjA2MiIgaGVpZ2h0PSIzMjIuODI2IiB2aWV3Qm94PSIwIDAgMTI4NS4wNjIgMzIyLjgyNiI+PHBhdGggZD0iTTE3NzUuODM0LDcxNS40SDc4OC4xMjRjLTYuNDQ0LDAtNDQuNjUxLDkyLjY3Ny01MC45NDIsOTIuNjc3czEuODQxLTI5Ny44MjYtNC42LTI5Ny44MjZTNjg0LjQsNzEzLjcxMSw2NzguNTY4LDcxMy43MTFoLTgwLjRsLTEwNy4yLDEuNjg4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDkwLjc3MiAtNDk3Ljc1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJyZ2JhKDksMTkxLDI1NSwwLjYpIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iMjUiIG9wYWNpdHk9IjAuMTMiLz48L3N2Zz4=";
export { SvgPulseLine2 as ReactComponent };